function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useIntlMemo from '@/hooks/useIntlMemo';
import { AuthProviders, UserLevels } from '@/types/server';
import { UserLevelColorMap } from '@/utils/constants';
import { Icon, Tag, Tooltip } from '@chakra-ui/react';
import { faBolt, faCrown, faGem, faHammer, faPeopleGroup, faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { faSword } from './icons/fontawesome/Sword';
import useChannelStore from '@/stores/ChannelStore';
var _obj;
var UserLevelIconMap = (_obj = {}, _define_property(_obj, UserLevels.EVERYONE, faPeopleGroup), _define_property(_obj, UserLevels.SUBSCRIBER, faStar), _define_property(_obj, UserLevels.REGULAR, faBolt), _define_property(_obj, UserLevels.MODERATOR, faSword), _define_property(_obj, UserLevels.TWITCH_VIP, faGem), _define_property(_obj, UserLevels.SOOP_VIP, faGem), _define_property(_obj, UserLevels.ADMIN, faHammer), _define_property(_obj, UserLevels.OWNER, faCrown), _obj);
function UserLevelTag(_param) {
    var userLevel = _param.userLevel, _param_showName = _param.showName, showName = _param_showName === void 0 ? true : _param_showName, _param_showIcon = _param.showIcon, showIcon = _param_showIcon === void 0 ? true : _param_showIcon, props = _object_without_properties(_param, [
        "userLevel",
        "showName",
        "showIcon"
    ]);
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var UserLevelMap = useIntlMemo(function(intl) {
        var _obj;
        return _obj = {}, _define_property(_obj, UserLevels.EVERYONE, intl.formatMessage({
            id: "2XDuH4",
            defaultMessage: [
                {
                    type: 0,
                    value: "Everyone"
                }
            ]
        })), _define_property(_obj, UserLevels.SUBSCRIBER, (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.YOUTUBE ? intl.formatMessage({
            id: "7L86Z5",
            defaultMessage: [
                {
                    type: 0,
                    value: "Member"
                }
            ]
        }) : intl.formatMessage({
            id: "FBaarm",
            defaultMessage: [
                {
                    type: 0,
                    value: "Subscriber"
                }
            ]
        })), _define_property(_obj, UserLevels.REGULAR, intl.formatMessage({
            id: "zz8eSp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Regular"
                }
            ]
        })), _define_property(_obj, UserLevels.MODERATOR, intl.formatMessage({
            id: "zA95/o",
            defaultMessage: [
                {
                    type: 0,
                    value: "Moderator"
                }
            ]
        })), _define_property(_obj, UserLevels.TWITCH_VIP, intl.formatMessage({
            id: "DrSbes",
            defaultMessage: [
                {
                    type: 0,
                    value: "Twitch VIP"
                }
            ]
        })), _define_property(_obj, UserLevels.SOOP_VIP, intl.formatMessage({
            id: "mC3JPP",
            defaultMessage: [
                {
                    type: 0,
                    value: "SOOP VIP"
                }
            ]
        })), _define_property(_obj, UserLevels.ADMIN, intl.formatMessage({
            id: "iHN12u",
            defaultMessage: [
                {
                    type: 0,
                    value: "Admin"
                }
            ]
        })), _define_property(_obj, UserLevels.OWNER, intl.formatMessage({
            id: "zINlao",
            defaultMessage: [
                {
                    type: 0,
                    value: "Owner"
                }
            ]
        })), _obj;
    }, [
        channel === null || channel === void 0 ? void 0 : channel.provider
    ]);
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: !showName ? UserLevelMap[userLevel] : '',
        "aria-label": UserLevelMap[userLevel],
        hasArrow: true,
        children: /*#__PURE__*/ _jsxs(Tag, _object_spread_props(_object_spread({
            variant: "subtle",
            size: "sm",
            colorScheme: UserLevelColorMap[userLevel],
            display: "flex",
            gap: 1,
            whiteSpace: "nowrap",
            justifyContent: "center"
        }, props), {
            children: [
                showIcon ? /*#__PURE__*/ _jsx(Icon, {
                    as: FontAwesomeIcon,
                    icon: UserLevelIconMap[userLevel]
                }) : null,
                showName ? UserLevelMap[userLevel] : null
            ]
        }))
    });
}
export default UserLevelTag;
